import { gql } from '@apollo/client';
import { genericItemFieldsFragment } from './index';

export const agencyItemsFragment = gql`
  fragment agencyItemFields on Item {
    ...GenericItemFields
    hasInternalLoan
    preview {
      thumbnail
      f460x345
    }
  }
  ${genericItemFieldsFragment}
`;
